import { userConstants } from "../constants/user.constants";

// Live RINUX rules (GET /admin/rules/:policyId) and their version history
const initialState = {
  rules: null,
  isLoading: true,
  error: null,
  versions: [],
  versionsLoading: true,
  versionsError: null,
};

export function RinuxRules(state = initialState, action) {
  switch (action.type) {
    case userConstants.RINUX_RULES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case userConstants.RINUX_RULES_SUCCESS:
      return { ...state, isLoading: false, rules: action.data };
    case userConstants.RINUX_RULES_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case userConstants.RINUX_RULE_VERSIONS_REQUEST:
      return { ...state, versionsLoading: true, versionsError: null };
    case userConstants.RINUX_RULE_VERSIONS_SUCCESS:
      return { ...state, versionsLoading: false, versions: action.data || [] };
    case userConstants.RINUX_RULE_VERSIONS_FAILURE:
      return { ...state, versionsLoading: false, versionsError: action.error };
    default:
      return state;
  }
}
